















import { Vue, Component, Prop } from "vue-property-decorator";

@Component({})
export default class AnxTableContainer extends Vue {
  /** Whether the table should be scrollable or not */
  @Prop({ default: null }) scrollable!: boolean | null;

  /** The height of the table container */
  @Prop({ default: null }) height!: string | null;
}
